import React, { useEffect } from 'react';

import { FacebookLoginClient } from './facebook-login.client';
import { isSafari } from './helpers';

export default function FacebookLogin(props) {
  const {
    appId,
    language = 'en_US',
    scope = 'public_profile, email',
    fields = 'name,email,picture',
    onSuccess,
    onFail,
    onProfileSuccess,
    className,
    style,
    children = 'Login with Facebook',
    render,
    autoLoad = false,
    useRedirect = false,
    useCustomerChat = false,
  } = props;

  const initParams = {
    version: 'v9.0',
    xfbml: false,
    cookie: false,
    localStorage: false,
    ...props.initParams,
    appId,
  };
  const dialogParams = {
    redirect_uri:
      typeof window !== 'undefined' ? location.origin + location.pathname : '/',
    state: 'facebookdirect',
    response_type: 'code',
    ...props.dialogParams,
    client_id: appId,
  };

  const loginOptions = {
    return_scopes: false,
    ignoreSdkError: false,
    ...props.loginOptions,
    auth_nonce:
      typeof props.loginOptions?.auth_nonce === 'function'
        ? props.loginOptions.auth_nonce()
        : props.loginOptions?.auth_nonce,
    scope,
  };

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    await FacebookLoginClient.loadSdk(language, useCustomerChat);
    window.fbAsyncInit = () => {
      FacebookLoginClient.init(initParams);
      const isRedirected = FacebookLoginClient.isRedirected(dialogParams);
      if (isRedirected === false && autoLoad) {
        handleButtonClick();
        return;
      }
      if (isRedirected === true && useRedirect) {
        requestLogin();
      }
    };
  };

  const onLoginSuccess = res => {
    onSuccess && onSuccess(res['authResponse']);

    if (onProfileSuccess) {
      FacebookLoginClient.getProfile(onProfileSuccess, { fields });
    }
  }

  const openFacebookLoginDialog = () => {
    FacebookLoginClient.login(
      (res) => {
        if (!res.authResponse) {
          onFail && onFail({ status: 'loginCancelled' });
          return;
        }
        onLoginSuccess(res)
      },
      { ...loginOptions, scope }
    );
  }

  const requestLogin = (skipStatusCheck = false) => {
    if (skipStatusCheck) {
      openFacebookLoginDialog();
      return;
    }

    FacebookLoginClient.getLoginStatus(function (res) {
        if (res.status === 'connected') {
          onLoginSuccess(res)
        } else {
          openFacebookLoginDialog();
        }
      },
      true)
  };

  const handleButtonClick = () => {
    // if (isFacebookApp() || useRedirect) {
    //   FacebookLoginClient.redirectToDialog(dialogParams, loginOptions);
    //   return;
    // }

    if (!window.FB) {
      onFail && onFail({ status: 'facebookNotLoaded' });
      return;
    }

    requestLogin(isSafari());
  };

  if (render) {
    return render({
      onClick: handleButtonClick,
      logout: FacebookLoginClient.logout,
    });
  }

  return (
    <button
      type="button"
      onClick={handleButtonClick}
      className={className}
      style={style}
    >
      {children}
    </button>
  );
}